import {
  Box, Button, Chip, Typography, CircularProgress,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import config from "../../config";
import axios from "axios";
import MailIcon from "@mui/icons-material/Mail";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import FmdGoodIcon from "@mui/icons-material/FmdGood";
import GridViewIcon from "@mui/icons-material/GridView";
import StoreIcon from "@mui/icons-material/Store";
import LoginIcon from "@mui/icons-material/Login";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import MiscellaneousServicesIcon from "@mui/icons-material/MiscellaneousServices";
import InquireDialog from "../listdetails/InquireDialog";
import ReviewModal from "./ReviewModal";
import { connect } from "react-redux";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const InfoRow = ({ label, children }) => (
  <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", py: 1, borderBottom: "1px solid #222" }}>
    <Typography sx={{ color: "#666", fontSize: "13px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", flexShrink: 0, mr: 2 }}>
      {label}
    </Typography>
    <Box sx={{ textAlign: "right" }}>{children}</Box>
  </Box>
);

const ServiceDetailCard = ({ listData, jwtToken, user }) => {
  const [open, setOpen] = useState(false);
  const [conversationId, setConversationId] = useState(null);
  const [openSucessAlert, setOpenSucessAlert] = useState(false);
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarStates, setSnackbarStates] = useState({ open: false, message: "", severity: "info" });
  const navigate = useNavigate();

  const d = {
    id: listData.id,
    name: listData.name,
    sellerId: listData.seller_id,
    serviceName: listData.service?.name,
    subserviceName: listData.sub_service?.name,
    price: listData.price,
    description: listData.description,
    shippingType: listData.seller?.store?.delivery_option,
    shippingDetails: listData?.shipping_details,
    img: listData.seller?.store?.brand_logo?.url,
    userId: listData.seller?.user?.id,
    storeId: listData?.seller?.store?.id,
    categoryId: listData?.service_id,
    brandName: listData.seller?.store?.brand_name,
    location: listData?.seller?.store?.location,
  };

  useEffect(() => {
    const getConversation = async () => {
      setLoading(true);
      try {
        const res = await axios.post(
          `${config.SERVER_URL}/conversations/check_existing_conversation`,
          { conversation: { listing_service_id: d.id } },
          { headers: { "Content-Type": "application/json", Authorization: `Bearer ${jwtToken}` } }
        );
        if (res.status === 200 && res.data.conversation_sid !== null) {
          setConversationId(res.data.conversation_sid);
        }
      } catch (e) {}
      setLoading(false);
    };
    getConversation();
  }, [d.id, jwtToken, openSucessAlert]);

  const handleOpen = () => {
    if (conversationId !== null) {
      navigate("/conversations", { state: { conversationId } });
    } else {
      setOpen(true);
    }
  };

  return (
    <>
      <Snackbar open={openSucessAlert} autoHideDuration={3000} onClose={() => setOpenSucessAlert(false)} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" onClose={() => setOpenSucessAlert(false)} severity="success">Message Sent Successfully!</MuiAlert>
      </Snackbar>
      <Snackbar open={snackbarStates.open} autoHideDuration={3000} onClose={() => setSnackbarStates((s) => ({ ...s, open: false }))} anchorOrigin={{ vertical: "bottom", horizontal: "right" }}>
        <MuiAlert elevation={6} variant="filled" severity={snackbarStates.severity} onClose={() => setSnackbarStates((s) => ({ ...s, open: false }))}>{snackbarStates.message}</MuiAlert>
      </Snackbar>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100%" }}>
          <CircularProgress sx={{ color: "#FFC001" }} />
        </Box>
      ) : (
        <>
          <InquireDialog page="Services" open={open} brandName={d.brandName} listData={listData} setOpen={setOpen} setOpenSucessAlert={setOpenSucessAlert} />
          <ReviewModal open={openReviewDialog} brandName={d.brandName} listData={listData} page="Services" setOpen={setOpenReviewDialog} setReviewOpenSucessAlert={() => {}} setSnackbarStates={setSnackbarStates} />

          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>

            {/* Title + category chips */}
            <Box>
              <Typography sx={{ color: "#fff", fontWeight: 800, fontSize: { xs: "22px", md: "28px" }, lineHeight: 1.2, mb: 1 }}>
                {d.name}
              </Typography>
              <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                {d.serviceName && (
                  <Chip
                    icon={<MiscellaneousServicesIcon sx={{ fontSize: "14px !important", color: "#FFC001 !important" }} />}
                    label={d.serviceName}
                    size="small"
                    sx={{ backgroundColor: "rgba(255,192,1,0.12)", color: "#FFC001", fontWeight: 600, fontSize: "11px", border: "1px solid rgba(255,192,1,0.3)" }}
                  />
                )}
                {d.subserviceName && (
                  <Chip label={d.subserviceName} size="small" sx={{ backgroundColor: "#1e1e1e", color: "#888", fontWeight: 500, fontSize: "11px", border: "1px solid #2a2a2a" }} />
                )}
              </Box>
            </Box>

            {/* Price */}
            <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", px: 2.5, py: 2 }}>
              <Typography sx={{ color: "#666", fontSize: "11px", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.5px", mb: 0.5 }}>Price</Typography>
              <Typography sx={{ color: "#FFC001", fontWeight: 800, fontSize: { xs: "28px", md: "36px" }, lineHeight: 1 }}>
                ${Number(d.price).toLocaleString()}
              </Typography>
              <Typography sx={{ color: "#555", fontSize: "12px", mt: 0.5 }}>USD · Payments accepted</Typography>
            </Box>

            {/* Details */}
            <Box sx={{ backgroundColor: "#1a1a1a", border: "1px solid #2a2a2a", borderRadius: "12px", px: 2, py: 0.5 }}>
              {d.description && (
                <InfoRow label="Description">
                  <Typography sx={{ color: "#ccc", fontSize: "14px", lineHeight: 1.6, textAlign: "right" }}>{d.description}</Typography>
                </InfoRow>
              )}
              {d.shippingDetails && (
                <InfoRow label="Shipping Info">
                  <Typography sx={{ color: "#ccc", fontSize: "14px" }}>{d.shippingDetails}</Typography>
                </InfoRow>
              )}
              <InfoRow label="Delivery">
                <Typography sx={{ color: "#ccc", fontSize: "14px" }}>
                  {d.shippingType === "regional_pickup" ? "Regional Pickup" : "Local Pickup"}
                </Typography>
              </InfoRow>
            </Box>

            {/* Seller / Store */}
            {d.brandName && (
              <Box
                component={Link}
                to={"/neighbour/" + d.storeId}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  backgroundColor: "#1a1a1a",
                  border: "1px solid #2a2a2a",
                  borderRadius: "12px",
                  p: 2,
                  textDecoration: "none",
                  transition: "all 0.25s ease",
                  "&:hover": { borderColor: "#FFC001" },
                }}
              >
                {d.img && (
                  <Box sx={{ width: 56, height: 56, borderRadius: "10px", overflow: "hidden", border: "1px solid #333", flexShrink: 0, backgroundColor: "#000" }}>
                    <img src={d.img} alt={d.brandName} style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                  </Box>
                )}
                <Box sx={{ flex: 1, minWidth: 0 }}>
                  <Typography sx={{ color: "#FFC001", fontWeight: 700, fontSize: "15px" }} noWrap>{d.brandName}</Typography>
                  {d.location && (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                      <FmdGoodIcon sx={{ color: "#555", fontSize: 14 }} />
                      <Typography sx={{ color: "#777", fontSize: "13px" }} noWrap>{d.location}</Typography>
                    </Box>
                  )}
                  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.3 }}>
                    <LocalShippingIcon sx={{ color: "#555", fontSize: 14 }} />
                    <Typography sx={{ color: "#777", fontSize: "13px" }}>
                      {d.shippingType === "regional_pickup" ? "Regional Pickup" : "Local Pickup"}
                    </Typography>
                  </Box>
                </Box>
                <StoreIcon sx={{ color: "#333", fontSize: 20, flexShrink: 0 }} />
              </Box>
            )}

            {/* Action buttons */}
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
              {!user && (
                <Button fullWidth variant="contained" startIcon={<LoginIcon />} onClick={() => navigate("/auth/login")}
                  sx={{ backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "15px", textTransform: "none", borderRadius: "10px", py: 1.3, "&:hover": { backgroundColor: "#e6ac00" } }}>
                  Login / Sign Up to Inquire
                </Button>
              )}
              {user && user.id !== d.userId && (
                <Button fullWidth variant="contained" startIcon={<MailIcon />} onClick={handleOpen}
                  sx={{ backgroundColor: "#FFC001", color: "#000", fontWeight: 700, fontSize: "15px", textTransform: "none", borderRadius: "10px", py: 1.3, "&:hover": { backgroundColor: "#e6ac00" } }}>
                  {conversationId ? "Go to Conversation" : "Inquire to Buy"}
                </Button>
              )}
              {conversationId && (
                <Button fullWidth variant="outlined" startIcon={<BorderColorIcon />} onClick={() => setOpenReviewDialog(true)}
                  sx={{ borderColor: "#FFC001", color: "#FFC001", fontWeight: 700, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.2, "&:hover": { backgroundColor: "rgba(255,192,1,0.08)" } }}>
                  Review Seller
                </Button>
              )}
              <Button fullWidth component={Link} to={"/services/listings/classes/" + d.categoryId} variant="outlined" startIcon={<GridViewIcon />}
                sx={{ borderColor: "#333", color: "#ccc", fontWeight: 600, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.1, "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>
                More Like This
              </Button>
              {d.storeId && (
                <Button fullWidth component={Link} to={"/services/listings/seller/" + d.sellerId} variant="outlined" startIcon={<StoreIcon />}
                  sx={{ borderColor: "#333", color: "#ccc", fontWeight: 600, fontSize: "14px", textTransform: "none", borderRadius: "10px", py: 1.1, "&:hover": { borderColor: "#FFC001", color: "#FFC001" } }}>
                  More from This Store
                </Button>
              )}
            </Box>
          </Box>
        </>
      )}
    </>
  );
};

const mapStateToProps = ({ Auth }) => ({
  jwtToken: Auth.jwtToken,
  user: Auth.user,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(ServiceDetailCard);
